const env = Object.freeze({
    environment: process.env.REACT_APP_ENV,
    isProduction: process.env.REACT_APP_ENV === 'production',
    apiUrl: process.env.REACT_APP_API_URL,
});

export default env
